module.exports = __webpack_public_path__ + "img/about-us.044de3af.jpg";